import { Directive, TemplateRef } from '@angular/core';

/**
 * Only used to inject templates and know what it is intended to replace
 */
@Directive({ selector: '[ui-accordion-header-template]' })
export class UIAccordionHeaderTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
